import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import { useProductsContext } from "../../context/products_context";
import { useCartContext } from "../../context/cart_context";
import { useLanguageContext } from "../../context/language_context";
import { useUserContext } from "../../context/user_context";
import { useOrderContext } from "../../context/order_context";
import {
  single_product_url as url,
  create_order_url,
} from "../../utils/constants";
import { formatPrice } from "../../utils/helpers";
import { Loading, Error, ReviewModal } from "../../components";
import Wrapper from "./styles";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import axios from "axios";
import {
  FaCheck,
  FaArrowLeft,
  FaStar,
  FaStarHalfAlt,
  FaRegStar,
  FaRulerCombined,
  FaCube,
} from "react-icons/fa";

const DEFAULT_SHIPPING_FEE = 7;

const SingleProductPage = () => {
  const { id } = useParams();
  const history = useHistory();
  const { t, isArabic } = useLanguageContext();
  const { currentUser } = useUserContext();
  const { fetchOrders } = useOrderContext();
  const {
    single_product_loading: loading,
    single_product_error: error,
    single_product: product,
    fetchSingleProduct,
  } = useProductsContext();
  const { addToCart } = useCartContext();

  const [selectedColor, setSelectedColor] = useState("");
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedOfferIndex, setSelectedOfferIndex] = useState(0);
  const [amount, setAmount] = useState(1);
  const [orderLoading, setOrderLoading] = useState(false);
  const [mainImage, setMainImage] = useState(null);

  // Customer info form state
  const [customerInfo, setCustomerInfo] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    governorate: "",
    city: "",
  });

  useEffect(() => {
    fetchSingleProduct(`${url}${id}`);
    setMainImage(null);
    setSelectedColor("");
    setSelectedSize("");
    setSelectedOfferIndex(0);
    setAmount(1);
    // eslint-disable-next-line
  }, [id]);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        history.push("/");
      }, 3000);
    }
    // eslint-disable-next-line
  }, [error]);

  const {
    name,
    price,
    description,
    stock,
    rating: stars,
    numberOfReviews,
    reviews = [],
    // _id: sku,
    ShopName,
    images,
    colors = [],
    sizes = [],
    specifications = [],
    shipping = true,
    isOffer = false,
    originalPrice = null,
    discountPercentage = 0,
    offers = [],
    variants = [],
  } = product;

  const colorVariant = Array.isArray(variants)
    ? variants.find((variant) => variant?.type === "color_buttons")
    : null;

  const hexToColorName = (hex) => {
    const colorMap = {
      "#ffffff": "Blanc",
      "#000000": "Noir",
      "#ff0000": "Rouge",
      "#00ff00": "Vert",
      "#0000ff": "Bleu",
      "#ffff00": "Jaune",
      "#ff6600": "Orange",
      "#800080": "Violet",
      "#ffc0cb": "Rose",
      "#808080": "Gris",
      "#c0c0c0": "Argent",
      "#a52a2a": "Marron",
      "#ff9900": "Orange",
      "#996633": "Marron",
      "#33cc33": "Vert",
      "#339933": "Vert foncé",
      "#9933ff": "Violet",
      "#cc33cc": "Magenta",
      "#6666ff": "Bleu clair",
      "#0099ff": "Bleu ciel",
      "#00cccc": "Cyan",
      "#333333": "Noir charbon",
      "#ffcc00": "Or",
    };
    return colorMap[(hex || "").toLowerCase()] || null;
  };

  const availableColors = colorVariant?.values?.length
    ? colorVariant.values
        .map((value) => {
          if (typeof value === "object") {
            return {
              name: value.name || hexToColorName(value.hex) || value.hex || "",
              hex: value.hex || value.name || "#FFFFFF",
            };
          }
          return {
            name: hexToColorName(value) || value,
            hex: value,
          };
        })
        .filter((value) => value.name)
    : colors.map((value, index) => ({
        name: hexToColorName(value) || `Color ${index + 1}`,
        hex: value,
      }));

  const hasOffers = Array.isArray(offers) && offers.length > 0;
  const selectedOffer = hasOffers ? offers[selectedOfferIndex] : null;
  const unitPrice = Number(selectedOffer?.price) || Number(price) || 0;
  const basePrice = Number(price) || 0;
  const highestOfferPrice = hasOffers
    ? offers.reduce((max, offer) => Math.max(max, Number(offer?.price) || 0), 0)
    : 0;
  let shippingPrice = 0;
  if (selectedOffer) {
    shippingPrice = Number(selectedOffer.shippingPrice) || 0;
  } else if (typeof shipping === 'number') {
    shippingPrice = shipping;
  } else if (shipping) {
    shippingPrice = DEFAULT_SHIPPING_FEE;
  }
  const subtotalPrice = unitPrice * amount;
  const totalPrice = subtotalPrice + shippingPrice;


  // Set default color and size when product loads
  useEffect(() => {
    if (availableColors.length > 0 && !selectedColor) {
      setSelectedColor(availableColors[0].hex);
    }
    if (sizes.length > 0 && !selectedSize) {
      setSelectedSize(sizes[0]);
    }
    if (images?.length > 0 && !mainImage) {
      setMainImage(images[0]);
    }
  }, [availableColors, sizes, images, selectedColor, selectedSize, mainImage]);

  useEffect(() => {
    if (!hasOffers) {
      return;
    }

    const bestOfferIndex = offers.reduce((bestIndex, offer, index, list) => {
      const currentPrice = Number(offer?.price) || 0;
      const bestPrice = Number(list[bestIndex]?.price) || 0;
      return currentPrice > 0 && (bestPrice === 0 || currentPrice < bestPrice)
        ? index
        : bestIndex;
    }, 0);

    setSelectedOfferIndex(bestOfferIndex);
  }, [id, hasOffers, offers]);

  useEffect(() => {
    document.title = `Art & Bois | ${name}`;

    // Meta Pixel - Track ViewContent
    if (window.fbq && product) {
      window.fbq("track", "ViewContent", {
        content_name: name,
        content_ids: [product._id],
        content_type: "product",
        value: unitPrice,
        currency: "TND",
      });
    }
  }, [name, product, unitPrice]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error />;
  }

  const originalCandidates = [
    Number(originalPrice) || 0,
    basePrice,
    highestOfferPrice,
  ].filter((value) => value > 0);
  let displayOriginalPrice = originalCandidates.length
    ? Math.max(...originalCandidates)
    : null;

  if (
    !(displayOriginalPrice > unitPrice) &&
    isOffer &&
    Number(discountPercentage) > 0 &&
    unitPrice > 0
  ) {
    const inferredOriginal = unitPrice / (1 - Number(discountPercentage) / 100);
    if (Number.isFinite(inferredOriginal) && inferredOriginal > unitPrice) {
      displayOriginalPrice = inferredOriginal;
    }
  }

  if (!(displayOriginalPrice > unitPrice)) {
    displayOriginalPrice = null;
  }

  const displayDiscount =
    displayOriginalPrice && displayOriginalPrice > unitPrice
      ? Math.round((1 - unitPrice / displayOriginalPrice) * 100)
      : Number(discountPercentage) || 0;

  const handleCustomerInfoChange = (e) => {
    const { name, value } = e.target;
    setCustomerInfo((prev) => ({ ...prev, [name]: value }));
  };

  const handleCashOnDelivery = async () => {
    // Validation
    if (!customerInfo.firstName) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!customerInfo.lastName) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!customerInfo.phone || customerInfo.phone.length < 8) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!customerInfo.governorate) {
      return toast.error(t.toasts.fillAllFields);
    }
    if (!customerInfo.city) {
      return toast.error(t.toasts.fillAllFields);
    }

    setOrderLoading(true);

    const shippingInfo = {
      address: customerInfo.city,
      city: customerInfo.city,
      state: customerInfo.governorate,
      country: "TN",
      pinCode: "0000",
      phoneNumber: customerInfo.phone,
    };

    const activeColorHexQD = selectedColor || availableColors[0]?.hex || "";
    const activeColorObjQD = availableColors.find(c => c.hex?.toLowerCase() === (activeColorHexQD || "").toLowerCase());
    const activeColorNameQD = activeColorObjQD ? activeColorObjQD.name : activeColorHexQD;

    const orderItems = [
      {
        name: product.name,
        price: unitPrice,
        quantity: amount,
        image: product.images[0]?.url || "",
        color: activeColorHexQD,
        colorName: activeColorNameQD,
        size: selectedSize || sizes[0] || "",
        product: product._id,
      },
    ];

    const paymentInfo = {
      id: "COD_" + Date.now(),
      status: "Cash on Delivery",
    };

    const itemsPrice = subtotalPrice;

    const body = {
      name: `${customerInfo.firstName} ${customerInfo.lastName}`,
      email: currentUser
        ? currentUser.email
        : `guest_${Date.now()}@cashondelivery.com`,
      shippingInfo,
      orderItems,
      paymentInfo,
      itemsPrice,
      shippingPrice,
      totalPrice,
    };

    try {
      await axios.post(create_order_url, body);

      // Meta Pixel - Track Purchase
      if (window.fbq) {
        window.fbq("track", "Purchase", {
          value: totalPrice,
          currency: "TND",
          content_ids: [product._id],
          content_type: "product",
        });
      }

      toast.success(t.toasts.orderSuccess);
      // Refetch orders if user is logged in
      if (currentUser) {
        await fetchOrders();
      }

      // Delay to allow Meta Pixel event to fire
      setTimeout(() => {
        setOrderLoading(false);
        // Reset form
        setCustomerInfo({
          firstName: "",
          lastName: "",
          phone: "",
          governorate: "",
          city: "",
        });
        setAmount(1);
        history.push("/");
      }, 3000);
    } catch (error) {
      toast.error(t.toasts.orderError);
      setOrderLoading(false);
    }
  };

  const handleAddToCart = () => {
    const activeColorHex = selectedColor || availableColors[0]?.hex;
    const activeColorObj = availableColors.find(c => c.hex?.toLowerCase() === (activeColorHex || "").toLowerCase());
    const activeColorName = activeColorObj ? activeColorObj.name : activeColorHex;

    const productForCart = {
      ...product,
      price: unitPrice,
      shipping: shippingPrice > 0,
      shippingPrice,
      selectedColorName: activeColorName,
    };

    addToCart(
      product._id,
      selectedColor || availableColors[0]?.hex,
      selectedSize || sizes[0],
      amount,
      productForCart,
    );

    // Meta Pixel - Track AddToCart
    if (window.fbq) {
      window.fbq("track", "AddToCart", {
        content_name: name,
        content_ids: [product._id],
        content_type: "product",
        value: unitPrice,
        currency: "TND",
      });
    }

    history.push("/cart");
  };

  const increase = () => {
    setAmount((oldAmount) => {
      let tempAmount = oldAmount + 1;
      if (tempAmount > stock) {
        tempAmount = stock;
      }
      return tempAmount;
    });
  };

  const decrease = () => {
    setAmount((oldAmount) => {
      let tempAmount = oldAmount - 1;
      if (tempAmount < 1) {
        tempAmount = 1;
      }
      return tempAmount;
    });
  };

  // Render stars helper
  const renderStars = (rating) => {
    const stars = [];
    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`full-${i}`} />);
    }
    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half" />);
    }
    const emptyStars = 5 - stars.length;
    for (let i = 0; i < emptyStars; i++) {
      stars.push(<FaRegStar key={`empty-${i}`} />);
    }
    return stars;
  };

  return (
    <Wrapper style={{ direction: isArabic ? "rtl" : "ltr" }}>
      {/* Breadcrumb */}
      <div className="breadcrumb-section">
        <nav className="breadcrumb">
          <Link to="/">{t.nav.home}</Link>
          <span>/</span>
          <Link to="/products">{t.nav.products}</Link>
          <span>/</span>
          <span className="current">{name}</span>
        </nav>
      </div>

      {/* Product Section */}
      <div className="product-section">
        <Link to="/products" className="back-btn">
          <FaArrowLeft />
          {t.singleProduct.backToProducts}
        </Link>

        <div className="product-center">
          {/* Product Images */}
          <div className="product-images">
            <div className="main-image-container">
              <img
                src={mainImage?.url || images?.[0]?.url}
                alt={name}
                className="main-image"
              />
              {stock > 0 && <span className="badge">{t.products.inStock}</span>}
            </div>
            <div className="thumbnail-gallery">
              {images?.map((image, index) => (
                <div
                  key={index}
                  className={`thumbnail ${mainImage?.url === image.url ? "active" : ""}`}
                  onClick={() => setMainImage(image)}
                >
                  <img src={image.url} alt={`${name} ${index + 1}`} />
                </div>
              ))}
            </div>
          </div>

          {/* Product Content */}
          <section className="content">
            <h1 className="product-title">{name}</h1>

            <div className="rating-section">
              <div className="stars">{renderStars(stars || 0)}</div>
              <span className="review-count">
                ({numberOfReviews || 0} {t.singleProduct.reviews})
              </span>
            </div>

            <div className="price-row">
              <h2 className="price">{formatPrice(unitPrice)}</h2>
              {displayOriginalPrice && (
                <>
                  <span className="old-price">
                    {formatPrice(displayOriginalPrice)}
                  </span>
                  <span className="discount-badge">-{displayDiscount}%</span>
                </>
              )}
            </div>

            <div className="product-info-section">
              {/* Professional Product Specifications */}
              <div className="product-specs">
                <h4
                  className="specs-title"
                  style={{
                    marginBottom: "1rem",
                    fontSize: "1.1rem",
                    fontWeight: 600,
                  }}
                >
                  {isArabic ? "مواصفات المنتج" : "Product Specifications"}
                </h4>

                <div
                  style={{
                    border: "1px solid #eaeaea",
                    borderRadius: "8px",
                    overflow: "hidden",
                    width: "100%",
                    marginBottom: "1.5rem",
                  }}
                >
                  <table
                    style={{
                      width: "100%",
                      borderCollapse: "collapse",
                      textAlign: isArabic ? "right" : "left",
                    }}
                  >
                    <tbody>
                      {/* Dynamic Specs */}
                      {(specifications || []).map((spec, idx) => (
                        <tr
                          key={idx}
                          style={{
                            borderBottom: "1px solid #eaeaea",
                            backgroundColor:
                              idx % 2 === 0 ? "#f9f9f9" : "white",
                          }}
                        >
                          <td
                            style={{
                              padding: "12px 16px",
                              fontWeight: "600",
                              color: "#555",
                              width: "40%",
                              borderRight: isArabic
                                ? "none"
                                : "1px solid #eaeaea",
                              borderLeft: isArabic
                                ? "1px solid #eaeaea"
                                : "none",
                            }}
                          >
                            {spec.name}
                          </td>
                          <td style={{ padding: "12px 16px", color: "#333" }}>
                            {spec.value}
                          </td>
                        </tr>
                      ))}

                      {/* Colors from Variants */}
                      {availableColors.length > 0 && (
                        <tr
                          style={{
                            borderBottom: "1px solid #eaeaea",
                            backgroundColor:
                              ((specifications && specifications.length) || 0) %
                                2 ===
                              0
                                ? "#f9f9f9"
                                : "white",
                          }}
                        >
                          <td
                            style={{
                              padding: "12px 16px",
                              fontWeight: "600",
                              color: "#555",
                              borderRight: isArabic
                                ? "none"
                                : "1px solid #eaeaea",
                              borderLeft: isArabic
                                ? "1px solid #eaeaea"
                                : "none",
                            }}
                          >
                            {isArabic ? "اللون" : "Couleur"}
                          </td>
                          <td
                            style={{
                              padding: "12px 16px",
                              color: "#333",
                              display: "flex",
                              gap: "8px",
                              flexWrap: "wrap",
                              alignItems: "center",
                            }}
                          >
                            {availableColors.map((color, index) => (
                              <span
                                key={index}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "4px",
                                }}
                              >
                                <span
                                  style={{
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    background: color.hex,
                                    border: "1px solid #ddd",
                                    display: "inline-block",
                                  }}
                                ></span>
                                {color.name}
                                {index < availableColors.length - 1 ? "," : ""}
                              </span>
                            ))}
                          </td>
                        </tr>
                      )}

                      {/* Old fallbacks for dimensions, material (ShopName) if they exist but specifications does not */}
                      {(!specifications || specifications.length === 0) &&
                        ShopName && (
                          <tr
                            style={{
                              borderBottom: "1px solid #eaeaea",
                              backgroundColor:
                                availableColors.length > 0
                                  ? "white"
                                  : "#f9f9f9",
                            }}
                          >
                            <td
                              style={{
                                padding: "12px 16px",
                                fontWeight: "600",
                                color: "#555",
                                borderRight: isArabic
                                  ? "none"
                                  : "1px solid #eaeaea",
                                borderLeft: isArabic
                                  ? "1px solid #eaeaea"
                                  : "none",
                              }}
                            >
                              {isArabic ? "المادة" : "Matériau"}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#333" }}>
                              {ShopName}
                            </td>
                          </tr>
                        )}
                      {(!specifications || specifications.length === 0) &&
                        sizes.length > 0 &&
                        sizes[0] && (
                          <tr
                            style={{
                              borderBottom: "1px solid #eaeaea",
                              backgroundColor:
                                (availableColors.length + (ShopName ? 1 : 0)) %
                                  2 ===
                                0
                                  ? "#f9f9f9"
                                  : "white",
                            }}
                          >
                            <td
                              style={{
                                padding: "12px 16px",
                                fontWeight: "600",
                                color: "#555",
                                borderRight: isArabic
                                  ? "none"
                                  : "1px solid #eaeaea",
                                borderLeft: isArabic
                                  ? "1px solid #eaeaea"
                                  : "none",
                              }}
                            >
                              {isArabic ? "الأبعاد" : "Dimensions"}
                            </td>
                            <td style={{ padding: "12px 16px", color: "#333" }}>
                              {sizes[0]}
                            </td>
                          </tr>
                        )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Stock Status */}
              <div
                style={{
                  marginBottom: "1rem",
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                  fontSize: "1.05rem",
                }}
              >
                <span style={{ fontWeight: 600 }}>
                  {isArabic ? "التوفر:" : "Disponibilité:"}
                </span>
                <span
                  style={{
                    color: stock > 0 ? "#38a169" : "#e53e3e",
                    fontWeight: 600,
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                  }}
                >
                  <FaCheck style={{ fontSize: "0.9em" }} />
                  {stock > 0
                    ? isArabic
                      ? "متوفر في المخزون"
                      : "En Stock"
                    : isArabic
                      ? "غير متوفر"
                      : "Rupture de Stock"}
                </span>
              </div>

              {description && <p className="desc">{description}</p>}
            </div>

            {stock > 0 ? (
              <>
                {/* Product Options */}
                <div className="product-options">
                  {/* Color Selection */}
                  {availableColors.length > 0 && (
                    <div className="option-group">
                      <span className="option-label">
                        {isArabic ? "اختر اللون" : "Select Color"}
                      </span>
                      <div className="colors">
                        {availableColors.map((color, index) => (
                          <button
                            key={index}
                            className={`color-btn ${selectedColor === color.hex ? "active" : ""}`}
                            style={{ background: color.hex }}
                            onClick={() => setSelectedColor(color.hex)}
                            title={color.name}
                          >
                            {selectedColor === color.hex && <FaCheck />}
                          </button>
                        ))}
                      </div>
                      <span className="selected-color-label">
                        {isArabic ? "اللون:" : "Color:"}{" "}
                        {availableColors.find(
                          (color) => color.hex === selectedColor,
                        )?.name || selectedColor}
                      </span>
                    </div>
                  )}

                  {hasOffers && (
                    <div className="option-group">
                      <span className="option-label">
                        {isArabic ? "اختر العرض" : "Choose your offer"}
                      </span>
                      <div className="offers-list">
                        {offers.map((offer, index) => {
                          const offerPrice = Number(offer.price) || 0;
                          const offerShipping =
                            Number(offer.shippingPrice) || 0;
                          const offerTotal =
                            offerPrice * amount + offerShipping;

                          return (
                            <button
                              key={index}
                              className={`offer-option ${selectedOfferIndex === index ? "active" : ""}`}
                              onClick={() => setSelectedOfferIndex(index)}
                              type="button"
                            >
                              <div className="offer-left">
                                <span className="offer-title">
                                  {offer.description ||
                                    `${isArabic ? "عرض" : "Offer"} ${index + 1}`}
                                </span>
                                <span className="offer-shipping">
                                  {offerShipping === 0
                                    ? isArabic
                                      ? "توصيل مجاني"
                                      : "Free delivery"
                                    : `${isArabic ? "Livraison" : "Delivery"}: ${formatPrice(offerShipping)}`}
                                </span>
                              </div>
                              <div className="offer-right">
                                <span>{formatPrice(offerTotal)}</span>
                              </div>
                            </button>
                          );
                        })}
                      </div>
                    </div>
                  )}

                  {/* Quantity */}
                  <div className="option-group">
                    <span className="option-label">{t.products.quantity}</span>
                    <div className="quantity-selector">
                      <button className="qty-btn" onClick={decrease}>
                        -
                      </button>
                      <span className="qty-value">{amount}</span>
                      <button className="qty-btn" onClick={increase}>
                        +
                      </button>
                    </div>
                  </div>
                </div>

                {/* Customer Information Form */}
                <div className="customer-form">
                  <h4>{t.customerForm.title}</h4>

                  <div className="form-grid">
                    <div className="form-row">
                      <div className="form-group">
                        <label>{t.customerForm.firstName}</label>
                        <input
                          type="text"
                          name="firstName"
                          value={customerInfo.firstName}
                          onChange={handleCustomerInfoChange}
                          placeholder={t.customerForm.firstName}
                        />
                      </div>
                      <div className="form-group">
                        <label>{t.customerForm.lastName}</label>
                        <input
                          type="text"
                          name="lastName"
                          value={customerInfo.lastName}
                          onChange={handleCustomerInfoChange}
                          placeholder={t.customerForm.lastName}
                        />
                      </div>
                    </div>

                    <div className="form-group">
                      <label>{t.customerForm.phone}</label>
                      <input
                        type="tel"
                        name="phone"
                        value={customerInfo.phone}
                        onChange={handleCustomerInfoChange}
                        placeholder={t.customerForm.phonePlaceholder}
                      />
                    </div>

                    <div className="form-row">
                      <div className="form-group">
                        <label>{t.customerForm.governorate}</label>
                        <input
                          type="text"
                          name="governorate"
                          value={customerInfo.governorate}
                          onChange={handleCustomerInfoChange}
                          placeholder={t.customerForm.governorate}
                        />
                      </div>
                      <div className="form-group">
                        <label>{t.customerForm.city}</label>
                        <input
                          type="text"
                          name="city"
                          value={customerInfo.city}
                          onChange={handleCustomerInfoChange}
                          placeholder={t.customerForm.city}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="order-summary">
                  <div className="summary-row">
                    <span>{isArabic ? "سعر الوحدة" : "Unit price"}</span>
                    <span>{formatPrice(unitPrice)}</span>
                  </div>
                  <div className="summary-row">
                    <span>{isArabic ? "المجموع الفرعي" : "Subtotal"}</span>
                    <span>{formatPrice(subtotalPrice)}</span>
                  </div>
                  <div className="summary-row">
                    <span>{isArabic ? "التوصيل" : "Delivery"}</span>
                    <span>
                      {shippingPrice === 0
                        ? isArabic
                          ? "مجاني"
                          : "Free"
                        : formatPrice(shippingPrice)}
                    </span>
                  </div>
                  <div className="summary-row total">
                    <span>{isArabic ? "الإجمالي" : "Total"}</span>
                    <span>{formatPrice(totalPrice)}</span>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="action-buttons">
                  <button
                    className="order-now-btn"
                    onClick={handleCashOnDelivery}
                    disabled={orderLoading}
                  >
                    {orderLoading ? t.common.loading : t.singleProduct.orderNow}
                  </button>
                  <button className="add-cart-btn" onClick={handleAddToCart}>
                    {t.singleProduct.addToCart}
                  </button>
                </div>
              </>
            ) : (
              <div className="out-of-stock-message">
                {t.products.outOfStock}
              </div>
            )}
          </section>
        </div>
      </div>

      {/* Reviews Section */}
      <section className="reviews-section">
        <div className="reviews-container">
          <div className="reviews-header">
            <h3>{t.singleProduct.customerReviews}</h3>
            <div className="reviews-summary">
              <div className="stars">{renderStars(stars || 0)}</div>
              <span className="rating-value">{stars?.toFixed(1) || "0.0"}</span>
              <span className="review-count">
                {numberOfReviews || 0} {t.singleProduct.reviews}
              </span>
            </div>
          </div>

          {reviews.length > 0 ? (
            <div className="reviews-grid">
              {reviews.map((review, index) => (
                <div key={index} className="review-card">
                  <div className="review-header">
                    <div className="stars">
                      {renderStars(review.rating || 5)}
                    </div>
                    <span className="date">
                      {review.createdAt
                        ? new Date(review.createdAt).toLocaleDateString()
                        : ""}
                    </span>
                  </div>
                  <h4 className="review-title">
                    {review.title || "Great product!"}
                  </h4>
                  <p className="review-text">{review.comment}</p>
                  <div className="reviewer">
                    {review.name}
                    <span className="verified">• Verified Buyer</span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="no-reviews">{t.singleProduct.noReviews}</p>
          )}

          <div className="review-modal-btn">
            <ReviewModal product={product} />
          </div>
        </div>
      </section>
    </Wrapper>
  );
};

export default SingleProductPage;
